import { TagCategory } from "../../model/tag/TagCategory";
import { api } from "../api";
import { parseTagCategory } from "../../parsers/tags/parseTagCategory";

export const postTagCategory = async (title: string): Promise<TagCategory> => {
  const response = await api.services.tagCategories.createTagCategory({ name: title });
  return parseTagCategory(response.data);
};
